import { useCallback } from "react";
import useFeedbackStore from "../store/useFeedbackStore";

/**
 * Hook for showing ephemeral action feedback (success, error, info, warning).
 * Backed by useFeedbackStore — safe to call from any React component or hook.
 * For non-React contexts (utils, plain functions), call useFeedbackStore.getState().showFeedback() directly.
 *
 * @returns {{ showFeedback: (message: string, type?: 'success'|'error'|'info'|'warning') => void }}
 */
const useFeedback = () => {
  const showFeedback = useFeedbackStore((state) => state.showFeedback);

  return { showFeedback: useCallback(showFeedback, [showFeedback]) };
};

export default useFeedback;
